import type { IconIndicatorProps } from "./icon-indicator.type";

import { getIconComponent } from "@/ui/icon-custom";

export const useIndicatorIcon = ({ type, isBig }: IconIndicatorProps) => {
  const iconExists = getIconComponent(type) ? true : false;

  const style = {
    fontSize: isBig ? "24px" : "16px",
    color: "#8d8c8c",
  };

  return {
    iconExists,
    style,
  };
};
